import { render, staticRenderFns } from "./ShowCartButton.vue?vue&type=template&id=50c61238"
import script from "./ShowCartButton.vue?vue&type=script&lang=ts"
export * from "./ShowCartButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports